import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closeDrawerButtonAriaLabel: {
    description: 'aria label for the close button in the drawer',
    defaultMessage: 'Close Fulfillments Wizard',
    id: 'BX5Ukf',
  },
  drawerHeaderText: {
    description: 'header text for the drawer',
    defaultMessage: 'Setup ShipStation Fulfillment',
    id: '3bDW3x',
  },
});
